import { Button, Group, Table } from '@mantine/core';
import { IconArrowNarrowRight } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import type { DepartmentDto } from '../../departments/types/DepartmentDto';
import { KeyedRow } from '../../../components/KeyedRow';

interface DepartmentRowProps {
	department: DepartmentDto;
}

export function GroupTotalDepartmentRow({ department }: DepartmentRowProps) {
	const navigate = useNavigate();

	const openSaleDetailsView = () => {
		navigate(`${department.id}`);
	};

	return (
		<>
			<KeyedRow>
				<Group
					py={0}
					my={0}
					justify={'space-between'}
					onClick={() => openSaleDetailsView()}
				>
					<Table.Td pl={'30px'}>{department.name}</Table.Td>
					<Table.Td>
						<Button
							rightSection={<IconArrowNarrowRight />}
							variant={'subtle'}
							color={'medepos.0'}
						>
							View Totals
						</Button>
					</Table.Td>
				</Group>
			</KeyedRow>
		</>
	);
}
